import * as React from 'react';
import SummaryCard from 'nomst/Components/SharedJobCollab/summaryCard';
import { navigateToNoMst } from 'utils/MobxDataManager/singletons';
import './jobCard.scss';

interface JobCardProps {
    jobTitle?: string;
    range?: string|JSX.Element;
    detail?: string;
    numberEmployees?: string;
    id?: Nullable<string|number>;
    jobCode?: Nullable<string>;
    className?: string;
}

const JobCard = (props: JobCardProps): JSX.Element => {
    const { id,
        jobCode,
        jobTitle,
        range,
        numberEmployees,
        className } = props;


    const onClickHandler = (): void => {
        if (!id || !jobCode) {
            return;
        }

        navigateToNoMst.navigateToJobDetails(jobCode, id);
    };

    return <SummaryCard
        className={`job-card ${className || ''}`}
        id={id ?? null}
        heading={jobTitle}
        subHeading={range}
        circleDisplay={numberEmployees}
        onClickHandler={onClickHandler}
    />;
};

export { JobCard };
export default JobCard;
